import get from "lodash.get";
import { buildDescription } from "./teamList";
import { getAssetURLMapping, getEntryURLMapping } from "./assets";

export const formatProjectsList = (data, isWebPSupported) => {
  const allProjectRawData = get(data, "data.items", []);
  const isHighRes = true;
  const assetURLsByID = getAssetURLMapping(
    data.data,
    isWebPSupported,
    isHighRes,
  );
  const entryByID = getEntryURLMapping(data.data);
  const allProjects = allProjectRawData.reduce((projects, project) => {
    const slideDeck = get(project, "fields.slidesDeck", []);
    const image_slides = slideDeck
      .map((slide) => {
        const entryId = get(slide, "sys.id");
        const slideEntry = entryByID[entryId];
        const mediaType = get(slideEntry, "fields.mediaType");
        if (mediaType === "Image") {
          const assetId = get(slideEntry, "fields.image.sys.id");
          return assetURLsByID[assetId];
        } else if (mediaType === "Video") {
          // Return the external video URL directly
          let url = get(slideEntry, "fields.videoUrl", "");

          if (!url.includes("https://")) {
            url = `${process.env.REACT_APP_CDN_URL}/${url}`;
          }
          return url;
        }
        return null;
      })
      .filter(Boolean);

    if (image_slides.length === 0) {
      console.info(
        `${get(
          project,
          "fields.projectTitle",
        )} does not have any published slides`,
      );
      return projects;
    }
    const featureImages = get(project, "fields.featureImages", []);
    let featured_image_src_landscape = null;
    let featured_image_src_portrait = null;

    featureImages.forEach((featureImageEntry) => {
      const featureImageEntryId = get(featureImageEntry, "sys.id");
      const featureEntry = entryByID[featureImageEntryId];

      const orientation = get(featureEntry, "fields.imageOrientation");
      const assetId = get(featureEntry, "fields.featureImage.sys.id");

      const assetURL =
        assetURLsByID[assetId] || get(featureEntry, "fields.videoUrl");

      if (!assetURL) return;

      if (orientation === "Landscape") {
        featured_image_src_landscape = assetURL;
      } else if (orientation === "Portrait") {
        featured_image_src_portrait = assetURL;
      }
    });

    const projectData = {
      project_type: get(project, "fields.projectCategory"),
      image_slides,
      project_order: get(project, "fields.slideOrder"),
      project_description: buildDescription(
        get(project, "fields.projectDescription.content"),
      ),
      project_credits: buildDescription(
        get(project, "fields.projectCredits.content"),
      ),
      slug: get(project, "fields.projectTitle", "")
        .replaceAll(" ", "-")
        .trim()
        .toLowerCase(),
      title: get(project, "fields.projectTitle"),
      featured_image_src_landscape,
      featured_image_src_portrait,
      priority: get(project, "fields.priority"),
      createdAt: get(project, "sys.createdAt"),
    };
    projects.push(projectData);
    return projects;
  }, []);
  return allProjects;
};

export const sortProjectsByPriority = (categorizedProjects) =>
  Object.keys(categorizedProjects).reduce((agg, category) => {
    const projects = categorizedProjects[category];
    const projectWithPriority = projects.filter(
      (project) => !!project.priority,
    );

    const projectWithoutPriority = projects.filter(
      (project) => !project.priority,
    );

    // Sort by priority first, then by createdAt date if priority is the same
    const sortedByPriority = projectWithPriority.sort((a, b) => {
      if (a.priority === b.priority) {
        // sort by createdAt date (oldest first)
        const dateA = new Date(a.createdAt || 0);
        const dateB = new Date(b.createdAt || 0);
        return dateA - dateB;
      }
      return a.priority - b.priority;
    });

    agg[category] = [...sortedByPriority, ...projectWithoutPriority];
    return agg;
  }, {});
